module.exports = __webpack_public_path__ + "src/assets/img/okkosport.e5674eab.jpg";